'use client';

import { useEffect, useState } from 'react';

/**
 * Горна граница за overlay-а. `window.load` чака ВСИЧКИ подресурси, включително
 * третите страни — GTM контейнерът сам е ~900 KB. Ако някой от тях се бави,
 * потребителят гледа loader върху страница, която отдавна е използваема.
 *
 * Скриването на `load` остава нарочно (без мигане, докато се качват корици и
 * шрифтове) — това е само таванът.
 */
export const MAX_VISIBLE_MS = 3000;

export default function GlobalLoader() {
  const [hidden, setHidden] = useState(false);
  const [mounted, setMounted] = useState(true);

  useEffect(() => {
    let hideTimer = null;
    let capTimer = null;
    let hiding = false;

    const hideLoader = () => {
      // `load` и таванът могат да стигнат дотук и двата — скриваме веднъж.
      if (hiding) {
        return;
      }
      hiding = true;
      if (capTimer != null) {
        window.clearTimeout(capTimer);
        capTimer = null;
      }
      setHidden(true);
      hideTimer = window.setTimeout(() => {
        setMounted(false);
      }, 300);
    };

    capTimer = window.setTimeout(hideLoader, MAX_VISIBLE_MS);

    if (document.readyState === 'complete') {
      hideLoader();
    } else {
      window.addEventListener('load', hideLoader, { once: true });
    }

    return () => {
      window.removeEventListener('load', hideLoader);
      if (hideTimer != null) {
        window.clearTimeout(hideTimer);
      }
      if (capTimer != null) {
        window.clearTimeout(capTimer);
      }
    };
  }, []);

  if (!mounted) {
    return null;
  }

  return (
    <div id="global-loader" className={hidden ? 'hide' : undefined} aria-hidden={hidden}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        className="gl-book"
        src="https://cdn.travogue.bg/assets/loader/book-loader.webp"
        alt=""
        width="120"
        height="120"
      />
    </div>
  );
}
